// Şehir listesi: hem manuel seçici hem de IP tespiti eşleştirmesi için.
// slug: statik SEO sayfası ile aynı; name: görünen ad; aliases: IP tespitinde eşleşecek adlar.
export const CITIES = [
  { slug: "istanbul", name: "İstanbul", aliases: ["istanbul"] },
  { slug: "istanbul-anadolu-yakasi", name: "İstanbul Anadolu Yakası", aliases: [] },
  { slug: "istanbul-avrupa-yakasi", name: "İstanbul Avrupa Yakası", aliases: [] },
  { slug: "gebze", name: "Gebze", aliases: ["gebze"] },
  { slug: "dilovasi", name: "Dilovası", aliases: ["dilovasi"] },
  { slug: "cayirova", name: "Çayırova", aliases: ["cayirova"] },
  { slug: "kocaeli", name: "Kocaeli", aliases: ["kocaeli", "izmit", "golcuk", "derince", "korfez", "basiskele"] },
  { slug: "bursa", name: "Bursa", aliases: ["bursa"] },
  { slug: "izmir", name: "İzmir", aliases: ["izmir"] },
  { slug: "konya", name: "Konya", aliases: ["konya"] },
  { slug: "gaziantep", name: "Gaziantep", aliases: ["gaziantep", "antep"] },
  { slug: "tekirdag", name: "Tekirdağ", aliases: ["tekirdag"] },
  { slug: "corlu", name: "Çorlu", aliases: ["corlu"] },
  { slug: "cerkezkoy", name: "Çerkezköy", aliases: ["cerkezkoy"] },
  { slug: "manisa", name: "Manisa", aliases: ["manisa"] },
  { slug: "adana", name: "Adana", aliases: ["adana"] },
  { slug: "denizli", name: "Denizli", aliases: ["denizli"] },
  { slug: "kayseri", name: "Kayseri", aliases: ["kayseri"] },
  { slug: "sakarya", name: "Sakarya", aliases: ["sakarya", "adapazari", "serdivan"] },
  { slug: "antalya", name: "Antalya", aliases: ["antalya"] },
  { slug: "mersin", name: "Mersin", aliases: ["mersin", "icel"] },
  { slug: "hatay", name: "Hatay", aliases: ["hatay", "antakya", "iskenderun"] },
  { slug: "eskisehir", name: "Eskişehir", aliases: ["eskisehir"] },
];

// Türkçe karakterleri sadeleştir + küçük harf
export function normalizeTr(s) {
  if (!s) return "";
  return String(s)
    .replace(/İ/g, "i")
    .replace(/I/g, "i")
    .replace(/ı/g, "i")
    .toLowerCase()
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ç/g, "c")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .trim();
}

// IP servisinden gelen city/region metnini bilinen bir şehre eşle
export function matchCity(cityStr, regionStr) {
  const c = normalizeTr(cityStr);
  const r = normalizeTr(regionStr);
  if (c) {
    for (const city of CITIES) {
      if (city.aliases.some((a) => c === a || c.includes(a))) return city;
    }
  }
  if (r) {
    for (const city of CITIES) {
      if (city.aliases.some((a) => r === a || r.includes(a))) return city;
    }
  }
  return null;
}

export function findBySlug(slug) {
  return CITIES.find((c) => c.slug === slug) || null;
}

// Şehir/semt bilgisi (başlık altı: "İstanbul · Kadıköy & Şişli")
export const DISTRICTS = {
  '': 'Ostim & Çankaya', // Ankara (genel/varsayılan)
  istanbul: 'Kadıköy & Şişli',
  'istanbul-anadolu-yakasi': 'Kadıköy & Ümraniye',
  'istanbul-avrupa-yakasi': 'Şişli & Beylikdüzü',
  gebze: 'GOSB & Güzeller',
  dilovasi: 'OSB & Diliskelesi',
  cayirova: 'Şekerpınar & Akse',
  kocaeli: 'İzmit & Gebze',
  bursa: 'Nilüfer & Osmangazi',
  izmir: 'Bornova & Çiğli',
  konya: 'Selçuklu & Meram',
  gaziantep: 'Şehitkamil & Şahinbey',
  tekirdag: 'Çorlu & Çerkezköy',
  corlu: 'Merkez & Velimeşe',
  cerkezkoy: 'OSB & Kızılpınar',
  manisa: 'Yunusemre & Şehzadeler',
  adana: 'Seyhan & Çukurova',
  denizli: 'Merkezefendi & Pamukkale',
  kayseri: 'Melikgazi & Kocasinan',
  sakarya: 'Adapazarı & Serdivan',
  antalya: 'Muratpaşa & Kepez',
  mersin: 'Yenişehir & Toroslar',
  hatay: 'Antakya & İskenderun',
  eskisehir: 'Odunpazarı & Tepebaşı',
};

export function districtsOf(slug) {
  return DISTRICTS[slug || ''] || 'Ostim & Çankaya';
}

// Sosyal kanıt: şehir + güne göre stabil, makul sayı (30–80). Simülasyon.
export function dailyCount(name) {
  const key = `${normalizeTr(name)}|${new Date().toISOString().slice(0, 10)}`;
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h * 31 + key.charCodeAt(i)) >>> 0;
  }
  return 30 + (h % 51); // 30..80
}

